import { Box, Typography } from '@mui/material'
import dayjs from 'dayjs'

const INACTIVE_STATUSES = ['Churn', 'Cancelled', 'Inactive / Paused']

const AverageTenureComponent = ({ objectData, dateField }) => {
  console.log('objectData', objectData)
  const startDate = objectData?.clientStartDate
  console.log('startDate', startDate)
  const daysActive = startDate ? dayjs().diff(dayjs(startDate), 'day') : 0
  console.log('daysActive', daysActive)
  const tenureDate = INACTIVE_STATUSES?.includes(objectData?.status) ? daysActive : null
  console.log('tenureDate', tenureDate)

  return (
    <Box>
      <Typography>{tenureDate}</Typography>
    </Box>
  )
}

export default AverageTenureComponent
